// The state of a named proof (31 TST-180) as a coloured word: passed, failed, or not run yet. A proof
// that has not been run is not green (decision record 0071). The word is always written out, so the
// colour is never the only sign (24 DES-561; WCAG 2.2 AA, 1.4.1).
import { adminText } from '../lib/copy';

export type ProofStateCode = 'green' | 'red' | 'not_run';

const CLASS: Record<ProofStateCode, string> = {
  green: 'chip ok',
  red: 'chip bad',
  not_run: 'chip none',
};

export function stateOfRun(run: { passed: boolean } | null | undefined): ProofStateCode {
  if (!run) return 'not_run';
  return run.passed ? 'green' : 'red';
}

export function ProofState({ state }: { state: string }) {
  const s: ProofStateCode = state === 'green' || state === 'red' ? state : 'not_run';
  return <span className={CLASS[s]}>{adminText(`proof_state.${s}`)}</span>;
}
